const backendUrl = "https://api357.cf.adapid.link/"
export const casesUrl = `${backendUrl}cs/api/v4/crs/data/`
export const account_details_url = `${backendUrl}cs/api/v4/transaction/disputed`
export const transaction_logs_url = `${backendUrl}cs/api/v4/crs/job_logs`
export const submit_action_url = `${backendUrl}cs/api/v4/job/attachment/upload`
export const response_logs_url = `${backendUrl}cs/api/I4C/response/ack/details`